var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarReview = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFBD13",
  d: "M7.81.585a.2.2 0 0 1 .38 0L9.751 5.39a.2.2 0 0 0 .19.138h5.052a.2.2 0 0 1 .117.362l-4.086 2.969a.2.2 0 0 0-.073.223l1.561 4.805a.2.2 0 0 1-.308.223l-4.086-2.969a.2.2 0 0 0-.236 0l-4.086 2.97a.2.2 0 0 1-.308-.224l1.56-4.805a.2.2 0 0 0-.072-.223L.89 5.889a.2.2 0 0 1 .117-.361H6.06a.2.2 0 0 0 .19-.138z"
})));
export { SvgStarReview as ReactComponent };
export default __webpack_public_path__ + "static/media/star-review.158f32a4.svg";